import React from 'react';
import { Steps, Button, Icon} from 'antd';
import './index.css';

// import views
import AuthenticateSession from './views/AuthenticateSession';
import SetRawFiles from './views/SetRawFiles';
import SetDatabase from './views/SetDatabase';
import SetParameters from './views/SetParameters';
import PreviewSession from './views/PreviewSession';
import SetWorkflow from './views/SetWorkflow';

// import data
import {defaultParameters, workflowOptions} from "./assets/constants/parameters";


class CreateSession extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      current: 0,
      parameters: defaultParameters, //parameter object
      visible: false,
      userEmail: "",
      sessionID: "",
    };
  }
  
  next() {
    const current = this.state.current + 1;
    this.setState({ current });
  }
  
  prev() {
    const current = this.state.current - 1;
    this.setState({ current });
  }

  authenticate = (auth, id, email)=>{
    // console.log(auth);
    if(auth){
      this.setState({
        current: this.state.current + 1,
        sessionID: id,
        userEmail: email,
      });
    }
  }

  // update the parameters for the current session
  updateParameters=(parameters)=>{
    console.log('session parameters udpated');
    // console.log(parameters);

    // make a deep clone of the updated object
    let _updatedParamerObject = JSON.parse(JSON.stringify(parameters));
    // console.log(_updatedParamerObject);

    // make a deep clone of the state.name object
    let currentParameterObject = JSON.parse(JSON.stringify(this.state.parameters));
    // console.log(currentParameterObject);

    // udpate the corresponding parameter in cloned object
    // Both Object.keys() and Object.values() returns an array
    // 
    // solution #1:
    // currentParameterObject[Object.keys(_updatedParamerObject)[0]] = Object.values(_updatedParamerObject)[0];
    // solution #2:
    let mergeObject = Object.assign({}, currentParameterObject, _updatedParamerObject);

    // update this.state.name object
    this.setState({
      parameters: mergeObject
    })
  }
  
  render() {
    // console.log(this.state);
    const { SERVER_APIS } = this.props;
    const { current, parameters } = this.state;
    const Step = Steps.Step;
    const steps = [
      {
        title: 'Session',
        content: <AuthenticateSession
          auth={this.authenticate}
          SERVER_APIS={SERVER_APIS} />,
      },
      {
        title: 'Workflow',
        content: <SetWorkflow 
          workflowOptions={workflowOptions}
          parameters={parameters}
          SERVER_APIS={SERVER_APIS}
          updateParameters={this.updateParameters}
        />
      },
      {
        title: 'Files',
        content: <SetRawFiles
          parameters={parameters}
          sessID={this.state.sessionID} 
          userEmail={this.state.userEmail}
          SERVER_APIS={SERVER_APIS}
          updateParameters={this.updateParameters} />,
      }, 
      {
        title: 'Database',
        content: <SetDatabase 
          parameters={parameters}
          SERVER_APIS={SERVER_APIS}
          updateParameters={this.updateParameters} />,
      }, 
      {
        title: 'Parameters',
        content: <SetParameters 
          parameters={parameters} 
          SERVER_APIS={SERVER_APIS}
          updateParameters={this.updateParameters} />,
      }
    ];

    return (
    <div>
      <Steps current={current}>
      {
        steps.map(item => <Step key={item.title} title={item.title} />)
      }
      </Steps>

      <div className="steps-content">
        {steps[current].content}
      </div>

      <div className="steps-action">
        <div className="step-action-btn-wrapper">
        {
          current > 0
          &&
          <Button style={{ marginLeft: 8 }} 
              icon="left"
              onClick={() => this.prev()}>Previous
          </Button>
        }
        {
          current === steps.length - 1
          &&
          <PreviewSession 
            parameters={parameters}
            email={this.state.userEmail}
            sessID={this.state.sessionID}
            SERVER_APIS={SERVER_APIS} />
        }
        {
          current < steps.length - 1
          &&
          current > 0
          &&
          <Button 
            style={{ marginLeft: 8 }} 
            type="primary"
            onClick={() => this.next()}>Next
            <Icon type="right" />
          </Button>
        }
        </div>
      </div>
    </div>);
  }
}

export default CreateSession;